module.exports = __webpack_public_path__ + "static/media/titleImg.9c95c736.png";